{
  "account": {
    "biometrics": {
      "download_biometrics": {
        "p1": "Stáhnout kopii mých biometrických údajů.",
        "title": "Stažení biometrických údajů"
      },
      "face": "Obličej",
      "iproov_config": {
        "opt_status": {
          "use_iproov": "Používat iProov (doporučeno)",
          "use_standard": "Použít alternativní metodu"
        },
        "p1": "Můžete zapnout nebo vypnout používání iProov.",
        "save": "Uložit změny",
        "title": "Konfigurace iProov"
      },
      "manage_biometrics": {
        "options": {
          "download": "Stáhnout biometrické údaje",
          "iproov": "Konfigurace iProov"
        },
        "title": "Správa biometrických údajů"
      },
      "voice": "Hlas"
    },
    "delete": {
      "button": "Potvrdit",
      "key": "SMAZAT MĚ",
      "label": "Pro potvrzení napište \"SMAZAT MĚ\" velkými písmeny.",
      "p1": "Svůj účet Nomidio ID můžete smazat.",
      "title": "Smazat účet"
    },
    "details": {
      "options": {
        "email": "E-mailové adresy",
        "names": "Jméno a příjmení",
        "phone": "Telefonní čísla"
      },
      "title": "Údaje o účtu"
    },
    "edit_details": {
      "alert": {
        "save_error": "Při aktualizaci vašich údajů došlo k chybě. Zkuste to prosím znovu.",
        "save_success": "Údaje o účtu byly aktualizovány"
      },
      "button": "Uložit změny",
      "leave_dialog": {
        "cancel": "Zrušit",
        "confirm": "Ano",
        "content": "Opravdu chcete opustit tuto stránku bez uložení změn?",
        "title": ""
      },
      "p1": "Můžete upravit své jméno spojené s vaším Nomidio ID.",
      "title": "Upravit údaje o účtu"
    },
    "email": {
      "approver": {
        "error": {
          "too_many_attempts": "Provedli jste příliš mnoho nesprávných pokusů. Zkuste to prosím znovu později.",
          "wrong_email": "Toto není e-mail, který byl zadán pro vašeho manažera. Ověřte to prosím s osobou, která vás pozvala, a zkuste to znovu."
        },
        "manager": {
          "title": "E-mailová adresa manažera"
        },
        "p1": "Při vytvoření vašeho firemního e-mailu byl jako váš schvalovatel určen konkrétní manažer.",
        "p2": "Tomuto manažerovi bude zaslán šestimístný ověřovací kód pro schválení vašeho e-mailu.",
        "title": "Zadejte e-mail manažera"
      },
      "button": "Upravit",
      "edit": {
        "add_email": {
          "button": "Přidat e-mail"
        },
        "delete_dialog": {
          "cancel": "Zrušit",
          "confirm": "Ano",
          "content": "Opravdu chcete smazat následující e-mail:",
          "title": ""
        },
        "delete_email": {
          "button": "Smazat",
          "error": "Při mazání této e-mailové adresy došlo k chybě. Zkuste to prosím znovu."
        },
        "fetch_error": "Při načítání aktuálních e-mailových adres došlo k chybě. Zkontrolujte prosím své připojení k internetu a obnovte stránku.",
        "new_email": {
          "button": "Odeslat ověřovací kód",
          "error.corporate_email": "Tento e-mail je firemní. Pro jeho přidání k vašemu účtu prosím kontaktujte podnikového správce.",
          "error.invalid_email": "Zadaná e-mailová adresa je neplatná.",
          "error.too_many_requests": "Odesíláte příliš mnoho požadavků. Před dalším pokusem prosím chvíli vyčkejte.",
          "error.unexpected_failure": "Při odesílání ověřovacího kódu na tento e-mail došlo k chybě. Zkuste to prosím znovu.",
          "title": "Přidat nový e-mail"
        },
        "primary_email": {
          "button": "Nastavit jako primární",
          "error": "Při aktualizaci primárního e-mailu došlo k chybě. Zkuste to prosím znovu."
        },
        "verify_pending": {
          "button": "Ověřit"
        }
      },
      "empty": "Na vašem účtu nejsou žádné e-mailové adresy.",
      "p1": "Seznam e-mailových adres spojených s vaším Nomidio ID.",
      "pin": {
        "failed_dialog": {
          "code_expired": "Ověřovací kód zaslaný na váš e-mail vypršel. Zadejte prosím svou e-mailovou adresu znovu k opětovnému ověření.",
          "default_content": "Nepodařilo se ověřit váš nový e-mail.",
          "email_in_use": "Ověřený e-mail je již spojen s jiným účtem. Zkuste to prosím znovu s jinou e-mailovou adresou.",
          "primary_button": "OK",
          "title": "Ověření se nezdařilo"
        },
        "success_dialog": {
          "primary_button": "OK",
          "title": "Váš e-mail byl úspěšně ověřen"
        }
      },
      "status": {
        "tooltip": {
          "pending": "Tento e-mail čeká na ověření.",
          "suspended": "Tento e-mail je pozastaven. Smažte jej prosím nebo požádejte podnikového správce o jeho opětovné aktivování.",
          "verified": "Tento e-mail je ověřen."
        }
      },
      "title": "E-mailové adresy",
      "type": {
        "corporate": "Firemní",
        "personal": "Osobní",
        "primary": "Primární"
      }
    },
    "enrolments": {
      "alert": {
        "save_error": "Aktualizace zapojení se nezdařila!",
        "save_success": "Zapojení aktualizováno!"
      },
      "button": {
        "cancel": "Zrušit",
        "retry": "Zkusit znovu",
        "save": "Aktualizovat"
      },
      "error": {
        "network_issue": "Zdá se, že máte potíže s připojením k internetu.",
        "server_error": "V současné době zaznamenáváme potíže. Zkuste to prosím znovu později."
      },
      "leave_dialog": {
        "cancel": "Zrušit",
        "confirm": "Ano",
        "content": "Opravdu chcete opustit tuto stránku bez uložení změn?",
        "title": ""
      },
      "p1": "Pro tyto společnosti používáte Nomidio ID.",
      "p2": "Kdykoli se můžete zapojit nebo odpojit.",
      "table": {
        "company_header": "Společnost",
        "enrolled_header": "Zapojeno",
        "select_all": "Vybrat vše"
      },
      "title": "Správa zapojených společností"
    },
    "export": {
      "button": "Stáhnout",
      "loading": "Načítání nejnovější verze vašich dat...",
      "p1": "Stáhnout kopii mých osobních údajů.",
      "title": "Stažení dat"
    },
    "history": {
      "action": {
        "ACCOUNT_DETAILS_UPDATED": "Údaje o účtu byly aktualizovány",
        "DATA_REQUESTED": "Biometrické údaje byly vyžádány",
        "DATA_SHARED": "Údaje byly sdíleny",
        "ENROLLED": "Zapojení dokončeno",
        "FACE_SAMPLE_DOWNLOAD": "Vzorek obličeje byl stažen",
        "HIGH_CHALLENGE": "Provedena vysoká výzva",
        "LOGIN": "Přihlášeno",
        "OPEN_ID_ACCOUNT_APPROVED": "Podnikové přihlášení přes Nomidio ID schváleno",
        "OPEN_ID_ACCOUNT_REMOVED": "Přístup k přihlášení přes Nomidio ID odebrán",
        "OPTED_IN": "Zapojení ke společnosti",
        "OPTED_OUT": "Odpojení od společnosti",
        "STANDARD_CHALLENGE": "Provedena standardní výzva",
        "TERMS_AND_CONDITIONS_ACCEPTED": "Podmínky použití přijaty",
        "TERMS_AND_CONDITIONS_REJECTED": "Podmínky použití odmítnuty",
        "VOICE_SAMPLE_DOWNLOAD": "Hlasový vzorek byl stažen"
      },
      "button": "Stáhnout",
      "p1": "Zobrazit seznam historických akcí na vašem účtu.",
      "performedWith": "Provedeno pomocí: ",
      "title": "Historie účtu"
    },
    "landing": {
      "logout": "Odhlásit se",
      "options": {
        "2fa": {
          "add": "Přidat dvoufaktorové ověřování",
          "loading": "Načítání...",
          "update": "Aktualizovat dvoufaktorové ověřování"
        },
        "account_details": "Údaje o účtu",
        "biometrics": "Správa biometrických údajů",
        "companies": "Zapojené společnosti",
        "delete": "Smazat moje Nomidio ID",
        "device": {
          "settings": "Nastavení zařízení"
        },
        "export": "Stažení dat",
        "faq": "FAQ",
        "help": "Nápověda",
        "history": "Historie účtu",
        "privacy": "Zásady ochrany osobních údajů",
        "terms": "Podmínky použití"
      },
      "title": "Správa účtu"
    },
    "logout_dialog": {
      "cancel": "Zrušit",
      "confirm": "Ano",
      "content": "",
      "title": "Opravdu se chcete odhlásit?"
    },
    "phone": {
      "button": "Upravit",
      "edit": {
        "delete_dialog": {
          "cancel": "Zrušit",
          "confirm": "Ano",
          "content": "Opravdu chcete smazat následující číslo:",
          "title": ""
        },
        "delete_phone": {
          "button": "Smazat",
          "error": "Při mazání tohoto telefonního čísla došlo k chybě. Zkuste to prosím znovu."
        },
        "fetch_error": "Při načítání aktuálních telefonních čísel došlo k chybě. Zkontrolujte prosím své připojení k internetu a obnovte stránku.",
        "leave_dialog": {
          "cancel": "Zrušit",
          "confirm": "Ano",
          "content": "Opravdu chcete opustit tuto stránku bez uložení změn?",
          "title": ""
        },
        "new_phone": {
          "button": "Ověřit",
          "error.landline": "Lze přidat pouze mobilní čísla.",
          "error.unexpected_failure": "Při odesílání ověřovacího kódu na váš telefon došlo k chybě. Zkuste to prosím znovu.",
          "title": "Přidat nové telefonní číslo"
        },
        "phone_list": {
          "title": "Upravit stávající telefonní čísla"
        },
        "primary_phone": {
          "button": "Nastavit jako primární",
          "error": "Při aktualizaci primárního telefonu došlo k chybě. Zkuste to prosím znovu."
        }
      },
      "empty": "Na vašem účtu nejsou žádná telefonní čísla.",
      "p1": "Seznam telefonních čísel spojených s vaším Nomidio ID.",
      "pin": {
        "failed_dialog": {
          "code_expired": "Ověřovací kód zaslaný na váš telefon vypršel. Zadejte prosím své telefonní číslo znovu k opětovnému ověření.",
          "default_content": "Nepodařilo se ověřit váš nový telefon, nebyl přidán.",
          "phone_in_use": "Ověřené telefonní číslo je již spojeno s jiným účtem. Zkuste to prosím znovu s jiným telefonním číslem.",
          "primary_button": "OK",
          "title": "Došlo k chybě"
        },
        "success_dialog": {
          "primary_button": "OK",
          "title": "Váš telefon byl úspěšně ověřen"
        }
      },
      "title": "Telefonní čísla",
      "type": {
        "dedicated_landline": "Vyhrazená pevná linka",
        "mobile": "Mobilní",
        "primary": "Primární",
        "shared_landline": "Sdílená pevná linka"
      }
    },
    "totp": {
      "continue": "Vytvořit tajný klíč pro ověřovací aplikaci",
      "description": "Přidejte dvoufaktorové ověřování pomocí aplikace pro ověřování.",
      "title": "Dvoufaktorové ověřování",
      "verified": {
        "confirm": "OK",
        "content": "Úspěšně jste přidali ověřovací aplikaci ke svému účtu.",
        "title": "TOTP ověřovací aplikace přidána"
      },
      "verify": {
        "authenticator": {
          "p1": "K dokončení tohoto kroku budete potřebovat ověřovací aplikaci ve svém zařízení. Doporučujeme použít aplikaci jako Google Authenticator.",
          "title": "Nemáte ověřovací aplikaci?"
        },
        "button": "Ověřit",
        "step1": {
          "title": "Krok 1. Naskenujte QR kód"
        },
        "step2": {
          "p1": "Zadejte 6místný ověřovací kód zobrazený v ověřovací aplikaci.",
          "p2": "Ověřovací kódy jsou časově omezeny, proto jej zadejte a klikněte na ověřit dříve, než se obnoví.",
          "title": "Krok 2. Zadejte bezpečnostní kód"
        },
        "title": "Zaregistrovat ověřovací aplikaci"
      },
      "warning": "Vytvoření nového tajného klíče automaticky deaktivuje stávající."
    },
    "welcome_dialog": {
      "content": "Vaše Nomidio ID bylo úspěšně vytvořeno. Obdržíte e-mail s dalšími informacemi o správě účtu.",
      "primary_button": "OK",
      "title": "Vítejte v Nomidio Identity"
    }
  },
  "auth": {
    "login": {
      "landing": {
        "p1": "Pro ověření pomocí Nomidio ID budete muset projít biometrickou kontrolou.",
        "title": "Vítejte v Nomidio ID"
      }
    }
  },
  "avatar": {
    "review": {
      "pending": "Čeká na schválení",
      "rejected": "Zamítnuto",
      "verified": "Ověřeno"
    },
    "upload": {
      "failed": "Tento obrázek nelze nastavit jako profilový.",
      "pending": "Nahrávání…"
    }
  },
  "branding": {
    "powered_by_pq": "Powered by Post-Quantum"
  },
  "browser_compatibility": {
    "android_web_view": {
      "li1": "Stiskněte nabídku v rohu",
      "li2": "Vyberte „Otevřít v Chrome“",
      "open": "Otevřete prosím tento odkaz v prohlížeči Chrome nebo Firefox. Postupujte prosím podle následujících kroků:",
      "title": "Tento prohlížeč v aplikaci není podporován."
    },
    "unsupported": {
      "direction": "Otevřete prosím tento odkaz v prohlížeči Chrome nebo Firefox pro Android nebo Safari pro iOS",
      "open": "Zdá se, že používáte nekompatibilní prohlížeč.",
      "title": "Nepodporovaný prohlížeč"
    }
  },
  "browser_problem_link": {
    "text": "Problém s prohlížečem?"
  },
  "challenge": {
    "pin": {
      "browser": {
        "click": "Klikněte sem pro zkopírování",
        "error": {
          "incomplete": "Zdá se, že vaše přihlášení bylo neúplné. Otevřete prosím odkaz znovu a zkuste to znovu.",
          "link": "Použitý odkaz byl nesprávný.",
          "request": "Při načítání vašeho ověřovacího kódu došlo k problému. Zkuste to prosím znovu později.",
          "unexpected": "Při načítání vašeho ověřovacího kódu došlo k neočekávané chybě."
        },
        "loading": "Načítání ověřovacího kódu…",
        "p1": "Děkujeme za ověření. Zkopírujte prosím níže uvedený ověřovací kód a zadejte jej v původním prohlížeči.",
        "tap": "Klepněte sem pro zkopírování",
        "title": "Vraťte se do původního prohlížeče."
      }
    }
  },
  "component": {
    "privacy_statement_link": {
      "link_text": "Zásady ochrany osobních údajů"
    }
  },
  "copy": {
    "button": {
      "error": "Při kopírování došlo k chybě. Zkopírujte prosím hodnotu ručně.",
      "success": "Zkopírováno!"
    }
  },
  "document": {
    "button": {
      "skip": "Přeskočit"
    },
    "error": {
      "loading": {
        "faq": "V tuto chvíli se nám nepodařilo načíst Nejčastěji kladené otázky. Zkontrolujte prosím své připojení k internetu a zkuste to znovu. Pokud tento problém přetrvává, kontaktujte nás prosím.",
        "privacy": "V tuto chvíli se nám nepodařilo načíst Zásady ochrany osobních údajů. Zkontrolujte prosím své připojení k internetu a zkuste to znovu. Pokud tento problém přetrvává, kontaktujte nás prosím.",
        "tnc": "V tuto chvíli se nám nepodařilo načíst Podmínky použití. Zkontrolujte prosím své připojení k internetu a zkuste to znovu. Pokud tento problém přetrvává, kontaktujte nás prosím."
      }
    }
  },
  "email_mfa": {
    "button": {
      "resend": "Znovu odeslat ověřovací kód",
      "verify": "Ověřit",
      "verifying": "Ověřování..."
    },
    "error": {
      "could_not_send": {
        "button": "požádejte o nový kód",
        "end": ".",
        "start": "Při odesílání ověřovacího kódu na váš e-mail došlo k chybě. Zkontrolujte prosím své připojení k internetu a poté "
      },
      "could_not_verify": "Při ověřování vašeho ověřovacího kódu došlo k chybě. Zkontrolujte prosím své připojení k internetu a klikněte znovu na ověřit.",
      "resend_limit": "Byl překročen limit opětovného odeslání e-mailu.",
      "resent_email": "Příliš mnoho pokusů s předchozím kódem, byl vám zaslán nový ověřovací kód. Zkuste to prosím znovu.",
      "timeout": "Váš ověřovací kód vypršel. Byl zaslán nový kód."
    },
    "instructions": {
      "email_available": "Zadejte prosím 6místný ověřovací kód, který byl zaslán na tuto e-mailovou adresu.",
      "email_not_available": "Zadejte prosím 6místný ověřovací kód, který byl zaslán na e-mailovou adresu spojenou s vaším účtem."
    },
    "resend_confirmation": "Ověřovací kód byl odeslán.",
    "title": "Ověřovací kód"
  },
  "error": {
    "generic": {
      "message": "Kontaktujte nás prosím ohledně této chyby.",
      "title": "Něco se pokazilo"
    }
  },
  "export": {
    "filename": "nomidio_id_data"
  },
  "external": {
    "faq": {
      "link": "Odkaz na FAQ."
    },
    "privacy": {
      "link": "Klikněte na odkaz na Zásady ochrany osobních údajů vaší společnosti."
    },
    "systemAdmin": {
      "email": "Kontaktujte prosím svého správce systému."
    },
    "tnc": {
      "link": "Klikněte na odkaz na Podmínky použití vaší společnosti."
    }
  },
  "face_check": {
    "check": {
      "biometrics": {
        "upload": "Nahrávání vašich biometrických údajů."
      },
      "button": {
        "camera": "Změnit kameru",
        "help": "Nápověda",
        "retry": "Zkusit znovu"
      },
      "desktop": {
        "tap_to_start": "Klikněte na tlačítko níže pro zahájení nahrávání"
      },
      "instructions": {
        "align": "Umístěte obličej do oválu a ujistěte se, že jsou vaše oči dobře viditelné.",
        "complete": "Dokončeno",
        "detected": "Nehýbejte se!",
        "timed_out": "Žádný obličej nebyl detekován"
      },
      "loading": "Načítání…",
      "needs_video": "Klikněte kamkoli pro aktivaci webové kamery",
      "processing": "Probíhá zpracování…",
      "refresh": "Prosím, neobnovujte stránku.",
      "tap_start": "Klepněte pro spuštění",
      "tap_to_start": "Klepněte sem pro spuštění",
      "uploading": "Nahrávání…"
    },
    "media_access": {
      "button": {
        "allow": "Povolit přístup ke kameře"
      },
      "p1": "Pro snímání vašeho biometrického otisku obličeje potřebujeme váš souhlas s přístupem ke kameře.",
      "p2": "Povolte prosím přístup ke kameře.",
      "title": "Přístup ke kameře"
    },
    "media_error": {
      "button": "Obnovit",
      "p1": "Zkuste prosím obnovit stránku nebo aktualizovat oprávnění přístupu ke kameře v nastavení prohlížeče.",
      "title": "Přístup ke kameře byl odepřen"
    },
    "orientation_error": {
      "title": "Vaše zařízení je v režimu na šířku. Otočte jej prosím!"
    }
  },
  "forms": {
    "email": {
      "label": "E-mailová adresa"
    },
    "first_name": {
      "error": {
        "maxlength": "Jméno je příliš dlouhé",
        "pattern": "Jméno není platné",
        "required": "Jméno je povinné"
      },
      "label": "Jméno"
    },
    "last_name": {
      "error": {
        "maxlength": "Příjmení je příliš dlouhé",
        "pattern": "Příjmení není platné",
        "required": "Příjmení je povinné"
      },
      "label": "Příjmení"
    }
  },
  "help": {
    "app_version": {
      "end": "",
      "start": "verze aplikace: "
    },
    "face_check": {
      "position": "Držte kameru ve výšce očí",
      "profile": "Osvětlete svůj obličej rovnoměrně"
    }
  },
  "index": {
    "incompatible": {
      "p1": "Toto zařízení nebo prohlížeč není schopen spustit tuto aplikaci.",
      "p2": "Možná bude nutné aktualizovat software nebo hardware.",
      "title": "Zařízení není podporováno"
    }
  },
  "iproov": {
    "failed": "Nepodařilo se ověřit váš biometrický otisk obličeje",
    "processing": "Biometrické údaje obličeje se zpracovávají",
    "timeout": {
      "heading": "CS Failed to initialise",
      "p1": "CS Please retry.",
      "p2": "CS If this problem is persisting, please reload the page."
    }
  },
  "language": {
    "choose": "Vyberte jazyk:",
    "cimode": "Debug"
  },
  "login": {
    "bio_intro": {
      "button": "Další",
      "list": {
        "item1": "Prostor je dobře osvětlen",
        "item2": "Zůstaňte v klidu 2–4 sekundy",
        "item3": {
          "desktop": "Nezakrýváte ani nezastíráte svůj obličej",
          "mobile": "Držíte zařízení v režimu na výšku"
        }
      },
      "listStart": "Ujistěte se prosím, že:",
      "title": "Nyní nahrajete video pro ověření vašich biometrických údajů obličeje"
    },
    "chooseEmail": {
      "error": {
        "p1": "E-maily tohoto účtu se nepodařilo načíst.",
        "p2": "Tento účet nemá žádné ověřené a schválené e-mailové adresy.",
        "p3": "E-maily tohoto účtu se nepodařilo načíst.",
        "p4": "Došlo k neočekávané chybě serveru.",
        "p5": "Při odesílání vašeho výběru došlo k chybě.",
        "p6": "Zkuste to prosím znovu."
      },
      "loading": "Načítání e-mailů...",
      "p1": "Váš účet má více e-mailových adres, pomocí kterých se lze přihlásit. Vyberte prosím jednu pro pokračování.",
      "retry": {
        "button": "Zkusit znovu"
      },
      "title": "Vyberte e-mailovou adresu pro přihlášení"
    },
    "deleted_dialog": {
      "content": "Váš účet byl úspěšně odstraněn z našeho systému.",
      "primary_button": "OK",
      "title": "Účet smazán"
    },
    "email": {
      "not_registered": {
        "p1": "Zdá se, že k této e-mailové adrese nemáte registrovaný žádný účet.",
        "p2": "Můžete se zaregistrovat s touto adresou nebo použít jinou e-mailovou adresu.",
        "register_button": "Zaregistrovat se",
        "retry_button": "Zkusit znovu",
        "title": "Žádný účet"
      }
    },
    "error": {
      "same_browser": {
        "p1": "Zdá se, že jste tento odkaz otevřeli ve stejném prohlížeči, ve kterém jste začali. Chcete-li pokračovat v přihlášení, otevřete odkaz v podporovaném prohlížeči nebo zařízení, na které přecházíte.",
        "title": "Použijte prosím svůj druhý prohlížeč"
      }
    },
    "failed_dialog": {
      "content": "Nepodařilo se ověřit vaši totožnost.",
      "primary_button": "OK",
      "server_error": "V současné době zaznamenáváme potíže. Zkuste to prosím znovu později.",
      "title": "Chyba přihlášení"
    },
    "landing": {
      "button": {
        "login": "Přihlásit se",
        "register": "Zaregistrovat se"
      },
      "error": {
        "account_locked": "Váš účet je momentálně zablokován. Zkuste to prosím později.",
        "auth_bad_state": "Nepodařilo se spustit ověřovací relaci.",
        "fail_into_key_recovery": "Při přihlašování došlo k chybě. Budete se muset přihlásit pomocí své registrované e-mailové adresy.",
        "forbidden": "Nejste oprávněni přihlásit se do této aplikace.",
        "generic": "Při přihlašování došlo k chybě.",
        "invalid_credentials": "Zadané přihlašovací údaje jsou neplatné.",
        "invalid_email": "Zadaná e-mailová adresa je neplatná.",
        "login_timeout": "Vaše relace skončila. Přihlaste se prosím znovu a pokračujte.",
        "max_mfa_reached": "Byl překročen limit opětovného odeslání ověřovacího kódu.",
        "oauth_bad_state": "Relaci OAuth2 se nepodařilo ověřit. Vraťte se prosím na přihlašovací obrazovku.",
        "recovery_server_error": "Váš účet se nepodařilo obnovit kvůli chybě serveru. Zkuste to prosím později.",
        "too_many_attempts": "Z tohoto zařízení bylo provedeno příliš mnoho pokusů o přihlášení. Zkuste to prosím znovu za 10 minut.",
        "unexpected_failure": "Při přihlašování došlo k chybě. Zkontrolujte prosím své připojení k internetu a zkuste to znovu.",
        "verification_image_error": "Při načítání ověřovacího obrázku došlo k chybě.",
        "verification_image_match": "Ověřovací obrázky propojující přihlášení napříč prohlížeči se musí shodovat.",
        "webauthn_cancelled": "Požadavek na přístupový klíč byl zrušen. Zkuste se prosím přihlásit znovu."
      },
      "key_recovery": {
        "p1": "Pro správu svého Nomidio ID se budete muset ověřit pomocí rozpoznávání obličeje a hlasu.",
        "p2": "Přihlaste se prosím pomocí své registrované e-mailové adresy."
      },
      "normal": {
        "p1": "Pro správu svého Nomidio ID se budete muset ověřit pomocí rozpoznávání obličeje a hlasu."
      },
      "privacy_link": "Zásady ochrany osobních údajů",
      "terms_link": "Podmínky použití",
      "title": "Vítejte ve svém účtu Nomidio ID"
    },
    "oauthEnded": {
      "body": "CS You may now close this window.",
      "title": "CS Login complete"
    },
    "polling": {
      "button": {
        "continue": "OK",
        "start_poll": "Pokračovat"
      },
      "network_issue": "Zdá se, že máte potíže s připojením k internetu.",
      "p1": "Může to trvat několik sekund. Prosím, neobnovujte stránku.",
      "server_error": "V současné době zaznamenáváme potíže. Zkuste to prosím znovu později.",
      "time_out": "Zpracování vašich biometrických údajů trvá déle, než jsme očekávali. Buď pokračujte v čekání, nebo to zkuste znovu později.",
      "title": "Ověřujeme vaši totožnost…"
    },
    "retry": {
      "button": "Zkusit znovu",
      "p1": "Zkuste to prosím znovu",
      "title": "Nepodařilo se ověřit vaši totožnost"
    },
    "webauthn": {
      "button": "Vytvořit můj klíč",
      "details": "To nám pomůže ověřit, že jste to vy, a umožní vám rychle se ověřit v budoucnu.",
      "dialog": "Možná budete muset tuto akci potvrdit ve svém prohlížeči nebo správci hesel.",
      "error": "Operace se nezdařila. Zkusit znovu?",
      "title": "Vytvořit klíč"
    }
  },
  "mfa": {
    "EMAIL": {
      "backup": "Nemám přístup ke svému e-mailu",
      "error.could_not_send.button": "požádejte o nový kód",
      "error.could_not_send.end": ".",
      "error.could_not_send.start": "Při odesílání ověřovacího kódu na váš e-mail došlo k chybě. Zkontrolujte prosím své připojení k internetu a poté ",
      "error.invalid_email": "Zadaná e-mailová adresa je neplatná.",
      "error.resend_limit": "Byl překročen limit opětovného odeslání e-mailu.",
      "instructions.p1": "Byl vám zaslán e-mail obsahující 6místný ověřovací kód.",
      "instructions.p2": "Zadejte prosím tento 6místný ověřovací kód.",
      "resend": "Znovu odeslat e-mailový ověřovací kód",
      "resent": "Byl vám zaslán nový ověřovací kód e-mailem.",
      "title": "E-mailový ověřovací kód"
    },
    "PHONE": {
      "backup": "",
      "error.could_not_send.button": "požádejte o nový kód",
      "error.could_not_send.end": ".",
      "error.could_not_send.start": "Při odesílání ověřovacího kódu na vaše telefonní číslo došlo k chybě. Zkontrolujte prosím své připojení k internetu a poté ",
      "error.resend_limit": "Byl překročen limit opětovného odeslání SMS.",
      "instructions.p1": "Zadejte prosím 6místný ověřovací kód zaslaný v SMS zprávě na toto telefonní číslo.",
      "instructions.p2": "",
      "resend": "Znovu odeslat SMS ověřovací kód",
      "resent": "Byl vám zaslán nový ověřovací kód.",
      "title": "Telefonní ověřovací kód"
    },
    "TOTP": {
      "backup": "Nemám přístup ke své ověřovací aplikaci",
      "instructions.p1": "Zadejte prosím 6místný ověřovací kód zobrazený ve vaší ověřovací aplikaci.",
      "instructions.p2": "Ověřovací kódy jsou časově omezeny, proto jej zadejte a klikněte na ověřit dříve, než vyprší.",
      "resend": "",
      "title": "Kód pro dvoufaktorové ověřování"
    },
    "verify": "Ověřit",
    "verifying": "Ověřování..."
  },
  "mobile": {
    "download": {
      "hint": "Pokud máte potíže se stahováním souborů do mobilního zařízení, zkuste to prosím znovu na stolním počítači."
    }
  },
  "nomidio": {
    "input": {
      "error": {
        "email": "Musí být platný e-mail",
        "exactlength": "Musí mít přesnou délku ",
        "forbidden": "Tato hodnota není povolena",
        "max": "Nesmí být více než ",
        "maxlength": "Délka nesmí být více než ",
        "min": "Musí být alespoň ",
        "minlength": "Délka musí být alespoň ",
        "otp": {
          "exactlength": " číslic je vyžadováno",
          "pattern": "Ověřovací kód musí obsahovat pouze čísla",
          "required": "Ověřovací kód je povinný",
          "retry": "Nesprávný ověřovací kód"
        },
        "pattern": "Tato hodnota není platná",
        "phone": "Musí být platné telefonní číslo",
        "required": "Toto pole je povinné"
      }
    },
    "phone": {
      "error": "Vyberte prosím jiné telefonní číslo",
      "number": "Telefonní číslo"
    }
  },
  "oauth": {
    "abort": {
      "continue": "Zpět",
      "p1": "Sdílení požadovaných dat nebylo schváleno, přihlášení bylo přerušeno.",
      "p2": "Přihlášení bylo přerušeno.",
      "title": "Přihlášení přerušeno"
    },
    "approval": {
      "button": {
        "accept": "Přijmout",
        "decline": "Odmítnout"
      },
      "checkbox": {
        "openid": "Souhlasím s použitím Nomidio ID"
      },
      "default": {
        "p1": {
          "end": ".",
          "middle": " požádalo o sdílení vašich dat Nomidio ID s ",
          "start": ""
        }
      },
      "openid": {
        "p1": {
          "end": ". Prosím zkontrolujte následující podmínky:",
          "middle": " chce použít vaše Nomidio ID pro přístup k ",
          "start": ""
        }
      },
      "p2": "Budou sdíleny následující údaje:",
      "privacy_policy": {
        "end": ".",
        "link": "naleznete zde",
        "start": "Více informací o tom, jak mohou být vaše data použita, "
      },
      "scope": {
        "email": "E-mail",
        "profile": "Jméno a příjmení"
      },
      "title": "Schválení"
    },
    "error": {
      "continue": "Zpět",
      "description": {
        "400": "Nesplnili jste jednu nebo více kontrol.",
        "401": "Nesplnili jste jednu nebo více kontrol.",
        "403": "Nejste oprávněni přihlásit se do této aplikace.",
        "404": "Chybí stav přihlášení třetí strany. Problém může vyřešit opětovný pokus o přihlášení.",
        "409": "Vaše relace vypršela. Zkuste to prosím znovu.",
        "429": "Byl překročen limit ověření. To může omezit přihlášení v příštím dni.",
        "500": "Došlo k chybě na webu nebo serveru. Zkuste se prosím znovu přihlásit.",
        "undefined": "Došlo k chybě na webu nebo serveru. Zkuste se prosím znovu přihlásit."
      },
      "p1": "Ověření se nezdařilo. Podrobnosti chyby naleznete níže.",
      "title": "Přihlášení se nezdařilo"
    },
    "login": {
      "landing": {
        "p1": "Pro přihlášení pomocí Nomidio ID budete muset projít biometrickou kontrolou.",
        "title": "Vítejte v přihlašování pomocí Nomidio ID"
      }
    }
  },
  "phone_mfa": {
    "button": {
      "resend": "Znovu odeslat ověřovací kód",
      "verify": "Ověřit",
      "verifying": "Ověřování..."
    },
    "error": {
      "conflict": "Telefonní číslo se již používá.",
      "could_not_send": {
        "button": "požádejte o nový kód",
        "end": ".",
        "start": "Při odesílání SMS ověřovacího kódu došlo k chybě. Zkontrolujte prosím své připojení k internetu a poté "
      },
      "could_not_verify": "Při ověřování vašeho ověřovacího kódu došlo k chybě. Zkontrolujte prosím své připojení k internetu a klikněte znovu na ověřit.",
      "resend_limit": "Byl překročen limit opětovného odeslání SMS.",
      "resent_code": "Příliš mnoho pokusů s předchozím kódem, byl vám zaslán nový ověřovací kód. Zkuste to prosím znovu.",
      "timeout": "Váš ověřovací kód vypršel. Byl zaslán nový kód."
    },
    "instructions": {
      "p1": "Zadejte prosím 6místný ověřovací kód zaslaný v SMS zprávě na toto telefonní číslo."
    },
    "new_pin_dialog": {
      "content": "Obdržíte SMS s novým 6místným ověřovacím kódem",
      "primary_button": "OK",
      "title": "Neplatný ověřovací kód."
    },
    "resend_confirmation": "Ověřovací kód byl odeslán.",
    "title": "Telefonní ověřovací kód"
  },
  "register": {
    "account_details": {
      "button": "Další",
      "intro": "Zadejte prosím své jméno, abychom mohli vytvořit vaše Nomidio ID.",
      "title": "Údaje o účtu"
    },
    "bio_intro": {
      "button": "Spustit",
      "list": {
        "item1": "Jste na tichém místě",
        "item2": "Můžete volně mluvit",
        "item3": "Prostor je dobře osvětlen",
        "item4": "Za vámi není přímé jasné světlo",
        "item5": {
          "desktop": "Nezakrýváte ani nezastíráte svůj obličej",
          "mobile": "Vaše zařízení je v režimu na výšku"
        }
      },
      "listStart": "Ujistěte se prosím, že:",
      "title": "Při snímání biometrických údajů pro vytvoření vašeho Nomidio ID se prosím ujistěte, že…"
    },
    "consent": {
      "button": {
        "accept": "Přijmout",
        "decline": "Odmítnout"
      },
      "checklist": {
        "general": "Souhlasím s použitím mých osobních údajů pro vytvoření mého Nomidio ID.",
        "general_enrol": {
          "end": ".",
          "start": "Souhlasím s použitím mých osobních údajů pro vytvoření mého Nomidio ID a s registrací mého Nomidio ID u "
        },
        "privacy": {
          "end": ".",
          "link": "Zásady ochrany osobních údajů",
          "start": "Potvrzuji, že jsem si přečetl/a "
        },
        "terms": {
          "end": ".",
          "link": "Podmínky použití",
          "start": "Potvrzuji, že jsem si přečetl/a a přijímám "
        },
        "title": "Pro pokračování musíte souhlasit s následujícím:"
      },
      "decline_dialog": {
        "cancel": "Zrušit",
        "confirm": "Ano",
        "content": "Nebudete moci vytvořit Nomidio ID",
        "title": "Opravdu chcete odmítnout?"
      },
      "error": {
        "bad_request": "Toto by se nemělo stát, ale vaše pozvánka se zdá být neplatná.",
        "conflict": "Vaši pozvánku bohužel nelze přijmout, možná vypršela nebo již byla použita.",
        "forbidden": "Vaši pozvánku bohužel nelze přijmout, možná je vaše telefonní číslo blokováno.",
        "unexpected_error": "Bohužel došlo k neočekávané chybě. Zkuste to prosím znovu."
      },
      "intro": {
        "enrol": {
          "end": ".",
          "start": "Vaše Nomidio ID bude po dokončení registrace zaregistrováno u "
        },
        "p1": "Pro vytvoření vašeho Nomidio ID budeme potřebovat shromáždit vaše jméno, mobilní číslo a e-mailovou adresu, jakož i váš hlasový biometrický vzor a biometrický otisk obličeje. Použijeme je k pomoci s ověřením vaší totožnosti u jiných společností. Vždy si vyžádáme váš souhlas před ověřením vaší totožnosti u nové společnosti a nikdy nesdílíme vaše biometrické údaje s nikým, pokud to není vyžadováno zákonem.",
        "p2": "Při ověřování vaší totožnosti vám může být zaslána SMS zpráva s ověřovacím kódem nebo odkazem.",
        "withdraw": "Svůj souhlas můžete kdykoli odvolat a spravovat svá další nastavení ochrany osobních údajů prostřednictvím webové aplikace."
      },
      "submitting": "Chvíli prosím počkejte.",
      "title": "Potřebujeme váš souhlas"
    },
    "consent_declined": {
      "p1": "Nebudete moci používat Nomidio Identity.",
      "title": "Odmítli jste Podmínky použití"
    },
    "email": {
      "already_verified": {
        "p1": "Zadejte prosím svou e-mailovou adresu. Pro obnovení registrace je vyžadován ověřovací kód e-mailu."
      },
      "button": "Odeslat ověřovací kód",
      "error": {
        "already_used": "Zadaná e-mailová adresa je již používána jiným uživatelem. Zkuste to prosím znovu s jinou e-mailovou adresou.",
        "corporate_email": "Tento e-mail je firemní. Pro jeho přidání k vašemu účtu prosím kontaktujte podnikového správce.",
        "email_mismatch": "Musíte ověřit e-mailovou adresu přiřazenou k této registraci. E-mailovou adresu můžete změnit po dokončení registrace.",
        "invalid_email": "Zadaná e-mailová adresa je neplatná.",
        "max_retry": "Byl překročen limit opětovného odeslání ověřovacího kódu.",
        "sending_email": "Při odesílání ověřovacího kódu na váš e-mail došlo k chybě. Zkuste to prosím znovu.",
        "too_many_requests": "Odesíláte příliš mnoho požadavků. Před dalším pokusem prosím chvíli vyčkejte."
      },
      "expired_notice": "Ověřovací kód zaslaný na váš e-mail vypršel. Zadejte prosím svůj e-mail znovu k opětovnému ověření.",
      "p1": "Zadejte prosím svou e-mailovou adresu. Bude vám zaslán 6místný ověřovací kód, který musíte zadat pro propojení vaší e-mailové adresy s vaším účtem Nomidio ID.",
      "title": "Údaje o účtu"
    },
    "email_confirmed": {
      "primary_button": "OK",
      "title": "Váš e-mail byl úspěšně ověřen"
    },
    "expired": {
      "p1": "Dokončení relace vám trvalo příliš dlouho.",
      "p2": "Tuto stránku nyní můžete zavřít.",
      "title": "Omlouváme se, tato pozvánka vypršela"
    },
    "face": {
      "camera": {
        "content": "Vyberte připojenou kameru ze seznamu.",
        "error": {
          "content": "Možná budete muset vybrat jiný zdroj videa.",
          "title": "Tuto kameru nelze použít"
        },
        "save": "Uložit",
        "title": "Změnit kameru"
      }
    },
    "face_failed": {
      "button": "Zkusit znovu",
      "error": {
        "bad_contrast": "Váš biometrický otisk obličeje má špatný kontrast. Zkuste to prosím znovu.",
        "bad_dynamic_range": "Váš biometrický otisk obličeje je špatně osvětlen a má nízký kontrast. Zkuste to prosím znovu.",
        "bad_exposure": "Expozice vašeho biometrického otisku obličeje není dostatečná. Zkuste to prosím znovu.",
        "bad_lighting": "Váš biometrický otisk obličeje má špatné osvětlení. Zkuste to prosím znovu v lépe osvětleném prostředí.",
        "bad_object": "Váš biometrický otisk obličeje nebyl dostatečně kvalitní pro zpracování. Zkuste to prosím znovu.",
        "bad_pose": "Zkuste to prosím znovu a držte kameru rovně.",
        "bad_sharpness": "Zkuste to prosím znovu a držte zařízení pevně.",
        "expired": "Vaše výzva nebo pozvánka vypršela.",
        "internal_error": "Došlo k neočekávané chybě. Zkuste to prosím znovu. Kód chyby: INTERNAL_ERROR.",
        "invalid_media": "Tento biometrický otisk obličeje se nepodařilo zpracovat. Zkuste to prosím znovu.",
        "invalid_sample_resolution": "Rozlišení vašeho biometrického otisku obličeje nebylo dostatečně vysoké. Zkuste to prosím znovu.",
        "object_not_found": "Váš obličej nelze jasně detekovat. Zkuste to prosím znovu.",
        "occlusion": "Zdá se, že vašemu obličeji něco překáží. Zkuste to prosím znovu.",
        "too_few_features": "Váš obličej nelze dostatečně podrobně detekovat. Zkuste to prosím znovu.",
        "too_few_objects": "Váš biometrický otisk obličeje neobsahoval dostatek detailů ke zpracování. Zkuste to prosím znovu.",
        "too_noisy": "Kvalita vašeho biometrického otisku obličeje nebyla dostatečná pro zpracování. Zkuste to prosím znovu.",
        "unknown": "Došlo k neočekávané chybě. Zkuste to prosím znovu.",
        "user_not_active": "Došlo k neočekávané chybě. Zkuste to prosím znovu. Kód chyby: USER_NOT_ACTIVE."
      },
      "title": "Nepodařilo se zaznamenat váš biometrický otisk obličeje"
    },
    "iproov": {
      "retry": "Zkusit znovu"
    },
    "landing": {
      "button": "Začít",
      "error": {
        "invalid": "Tato pozvánka není platná. Zkontrolujte, zda jste použili nejnovější odkaz.",
        "session": "Registrační relace vypršela. Zadejte prosím své údaje znovu."
      },
      "p1": "Prokažte svou totožnost důvěryhodným společnostem a mějte kontrolu nad údaji, které s nimi sdílíte.",
      "title": "Vytvořte své Nomidio ID"
    },
    "link": {
      "failed_dialog": {
        "primary_button": "OK"
      }
    },
    "oauth_final": {
      "p1": {
        "end": " a přihlaste se pomocí nově vytvořeného účtu.",
        "start": "Byli jste úspěšně zaregistrováni. Vraťte se prosím na "
      },
      "title": "Registrace dokončena"
    },
    "phone": {
      "already_verified": {
        "p1": "Zadejte prosím své telefonní číslo. Pro obnovení registrace je vyžadován ověřovací kód telefonu."
      },
      "button": "Odeslat ověřovací kód",
      "error": {
        "already_used": "Zadané telefonní číslo je již používáno jiným uživatelem. Zkuste to prosím znovu s jiným telefonním číslem.",
        "invalid_mobile": "Toto není platné mobilní číslo.",
        "max_retry": "Byl překročen limit opětovného odeslání ověřovacího kódu.",
        "phone_mismatch": "Musíte ověřit telefonní číslo přiřazené k této registraci. Telefonní číslo můžete změnit po dokončení registrace.",
        "sending_phone": "Při odesílání ověřovacího kódu na váš telefon došlo k chybě. Zkuste to prosím znovu.",
        "too_many_requests": "Odesíláte příliš mnoho požadavků. Před dalším pokusem prosím chvíli vyčkejte."
      },
      "expired_notice": "Ověřovací kód zaslaný na váš telefon vypršel. Zadejte prosím své telefonní číslo znovu k opětovnému ověření.",
      "p1": "Zadejte prosím své telefonní číslo. Bude vám zaslán 6místný ověřovací kód, který musíte zadat pro propojení vašeho telefonu s vaším účtem Nomidio ID.",
      "skip": "Přeskočit",
      "title": "Údaje o účtu"
    },
    "phone_confirmed": {
      "button": "OK",
      "title": "Vaše telefonní číslo bylo úspěšně ověřeno"
    },
    "post_creation": {
      "continue": "Pokračovat",
      "option": {
        "avatar": {
          "cta": "Nahrát",
          "desc": "Přizpůsobte si účet přidáním avatara.",
          "label": "Nahrát profilový obrázek"
        },
        "totp": {
          "cta": "Nastavit",
          "desc": "Přidejte další vrstvu zabezpečení svého účtu.",
          "label": "Přidat dvoufaktorové ověřování"
        }
      },
      "p1": "Váš účet byl vytvořen. Následující volitelné údaje můžete přidat nyní nebo je nastavit později.",
      "title": "Vše je připraveno"
    },
    "redirect": {
      "link": "klikněte zde",
      "p1": "Dokončili jste registraci a nyní budete přesměrováni na další část procesu.",
      "p2": "Mělo by to trvat jen několik sekund. Pokud se nic nestane, prosím ",
      "title": "Přesměrování..."
    },
    "renew": {
      "button": "Pokračovat",
      "error": {
        "could_not_renew": "Nepodařilo se obnovit vaši pozvánku. Zkuste to prosím znovu."
      },
      "p1": "Tato registrace byla před dokončením dlouho přerušena. Budete muset část registrace zopakovat.",
      "title": "Obnovení registrace"
    },
    "skip": {
      "interaction": "Příště nezobrazovat"
    },
    "summary": {
      "button": "Odeslat",
      "email": "E-mail",
      "name_edit": "Upravit",
      "phone": "Mobilní číslo",
      "title": "Ověřit osobní údaje"
    },
    "totp": {
      "p1": "Přidejte dvoufaktorové ověřování pomocí aplikace pro ověřování",
      "qr": {
        "loading": "Načítání QR kódu..."
      },
      "step1": {
        "title": "Krok 1. Naskenujte QR kód"
      },
      "step2": {
        "title": "Krok 2. Zadejte bezpečnostní kód"
      },
      "submit": "Potvrdit",
      "title": "Dvoufaktorové ověřování"
    },
    "verify_face": {
      "failed": {
        "button": "Zkusit znovu",
        "p1": "Nepodařilo se ověřit vaše biometrické údaje. Zkuste to prosím znovu.",
        "title": "Neúspěšné!"
      },
      "intro": {
        "button": "Pokračovat",
        "option": {
          "iproov.desc": "Nejrychlejší a nejbezpečnější metoda.",
          "iproov.label": "Použít ověření přes iProov",
          "recommended": "Doporučeno",
          "standard.desc": "Tento proces může trvat déle.",
          "standard.label": "Použít alternativní metodu"
        },
        "p1": "Pro potvrzení zabezpečení vašeho účtu potřebujeme ověřit vaši totožnost pomocí rychlého biometrického skenování.",
        "p2": {
          "href": "https://www.iproov.com/blog/iproov-safeguards-for-people-with-photosensitive-epilepsy",
          "part1": "Používáme ",
          "part2": "iProov",
          "part3": ", zabezpečenou biometrickou ověřovací službu. iProov využívá kameru vašeho zařízení a může zahrnovat krátkou sekvenci blikajících světel k potvrzení, že jste skutečná osoba.",
          "title": "Jak to funguje"
        },
        "p3": "Svůj souhlas můžete kdykoli aktualizovat v nastavení účtu.",
        "title": "Ověřování vašeho obličeje"
      },
      "opt_out_dialog": {
        "cancel": "Zrušit",
        "confirm": "Vypnout iProov",
        "p1": "Vypnutím ověření přes iProov budete muset ověřit svou totožnost alternativní metodou, která může trvat déle.",
        "p2": "Opravdu chcete vypnout ověření přes iProov?",
        "title": "Vypnout iProov"
      },
      "retry": {
        "p2": "Budete muset znovu zaznamenat své biometrické údaje.",
        "title": "Opakovat biometrické ověření"
      }
    },
    "verify_voice": {
      "failed": {
        "button": "Zkusit znovu",
        "p1": "Nepodařilo se dokončit váš hlasový biometrický vzor. Zkuste to prosím znovu.",
        "title": "Neúspěšné!"
      }
    },
    "webauthn": {
      "button": "Vytvořit můj klíč",
      "details": "To nám pomůže ověřit, že jste to vy, a umožní vám rychle se ověřit v budoucnu.",
      "dialog": "Možná budete muset tuto akci potvrdit ve svém prohlížeči nebo správci hesel.",
      "error": "Operace se nezdařila. Zkusit znovu?",
      "title": "Vytvořit klíč"
    }
  },
  "registration": {
    "consent": {
      "button": {
        "accept": "Přijmout",
        "decline": "Odmítnout"
      },
      "checklist": {
        "general": "Souhlasím s použitím mých osobních údajů pro vytvoření mého Nomidio ID.",
        "privacy": {
          "end": ".",
          "link": "Zásady ochrany osobních údajů",
          "start": "Potvrzuji, že jsem si přečetl/a "
        },
        "terms": {
          "end": ".",
          "link": "Podmínky použití",
          "start": "Potvrzuji, že jsem si přečetl/a a přijímám "
        },
        "title": "Pro pokračování musíte souhlasit s následujícím:"
      },
      "intro": {
        "p1": "Pro vytvoření vašeho Nomidio ID budeme potřebovat shromáždit vaše jméno, mobilní číslo a e-mailovou adresu, jakož i váš hlasový biometrický vzor a biometrický otisk obličeje. Použijeme je k pomoci s ověřením vaší totožnosti u jiných společností. Vždy si vyžádáme váš souhlas před ověřením vaší totožnosti u nové společnosti a nikdy nesdílíme vaše biometrické údaje s nikým, pokud to není vyžadováno zákonem.",
        "p2": "Při ověřování vaší totožnosti vám může být zaslána SMS zpráva s ověřovacím kódem nebo odkazem.",
        "p3": "Svůj souhlas můžete kdykoli odvolat a spravovat svá další nastavení ochrany osobních údajů prostřednictvím webové aplikace."
      },
      "title": "Potřebujeme váš souhlas"
    },
    "creating": {
      "p1": "Nastavujeme zbytek vaší registrace. Prosím, počkejte.",
      "title": "Vytváření vaší registrace"
    },
    "email": {
      "button": "Odeslat ověřovací kód",
      "error": {
        "already_used": "Zadaná e-mailová adresa je již používána jiným uživatelem. Zkuste to prosím znovu s jinou e-mailovou adresou.",
        "invalid_email": "Zadaná e-mailová adresa je neplatná.",
        "unexpected_failure": "Při odesílání ověřovacího kódu na váš e-mail došlo k chybě. Zkuste to prosím znovu."
      },
      "expired_notice": "Ověřovací kód zaslaný na váš e-mail vypršel. Zadejte prosím svůj e-mail znovu k opětovnému ověření.",
      "p1": "Zadejte prosím svou e-mailovou adresu. Bude vám zaslán 6místný ověřovací kód, který musíte zadat pro ověření vašeho e-mailu.",
      "title": "E-mail"
    },
    "error": {
      "corporate_email": {
        "button": {
          "retry": "Použít jiný e-mail"
        },
        "p1": "Zadaný e-mail je firemní. Pro jeho přidání k vašemu účtu prosím kontaktujte podnikového správce.",
        "p2": "Zaregistrujte se prosím pomocí osobního e-mailu.",
        "title": "Firemní e-mail"
      },
      "email_in_use": {
        "button": {
          "login": "Přihlásit se",
          "retry": "Použít jiný e-mail"
        },
        "p1": "Ověřený e-mail je již spojen s existujícím účtem.",
        "p2": "Můžete zkusit zaregistrovat se s jiným e-mailem nebo se přihlásit pomocí ověřeného e-mailu.",
        "title": "E-mail se již používá"
      },
      "email_phone_in_use": {
        "button": {
          "retry": "Použít jiné údaje"
        },
        "p1": "Ověřený e-mail i telefonní číslo jsou již spojeny s existujícími účty.",
        "p2": "Zkuste prosím zaregistrovat se s jinými údaji.",
        "title": "Telefonní číslo i e-mail se již používají"
      },
      "email_restricted": {
        "p1": "Nejste oprávněni zaregistrovat se pomocí tohoto odkazu.",
        "title": "Registrace zakázána"
      },
      "invalid_domain": {
        "p1": "Odkaz, který jste použili, se nepodařilo najít. Buď odkaz neexistuje, nebo nebyl aktivován.",
        "p2": "Registraci bohužel nelze dokončit.",
        "title": "Registrační odkaz nenalezen"
      },
      "link_not_found": {
        "p1": "Odkaz, který jste použili, se nepodařilo najít. Buď odkaz neexistuje, nebo vypršel.",
        "p2": "Registraci bohužel nelze dokončit.",
        "title": "Registrační odkaz nenalezen"
      },
      "phone_in_use": {
        "button": {
          "login": "Přihlásit se",
          "retry": "Použít jiné číslo"
        },
        "p1": "Ověřené telefonní číslo je již spojeno s existujícím účtem.",
        "p2": "Můžete zkusit zaregistrovat se s jiným telefonním číslem nebo se přihlásit k existujícímu účtu.",
        "title": "Telefonní číslo se již používá"
      },
      "server_error": {
        "button": "Zkusit znovu",
        "p1": "V současné době zaznamenáváme potíže s vaší registrací. Prosím, vyčkejte a zkuste to znovu.",
        "title": "Chyba serveru"
      },
      "session_expired": {
        "button": "Restartovat",
        "p1": "Registrační relace vypršela. Zadejte prosím své údaje znovu.",
        "title": "Relace vypršela"
      },
      "too_many_requests": {
        "p1": "Odesíláte příliš mnoho požadavků. Registraci bohužel nelze dokončit.",
        "title": "Příliš mnoho požadavků"
      },
      "user_already_registered": {
        "button": {
          "login": "Přihlásit se"
        },
        "p1": "Ověřený e-mail i telefonní číslo jsou již spojeny s existujícím účtem.",
        "title": "Uživatel je již registrován"
      }
    },
    "phone": {
      "button": "Odeslat ověřovací kód",
      "error": {
        "invalid_mobile": "Toto není platné mobilní číslo."
      },
      "p1": "Zadejte prosím své mobilní číslo. Bude vám zaslán 6místný ověřovací kód, který musíte zadat pro ověření svého mobilního čísla.",
      "title": "Mobilní číslo"
    }
  },
  "shared": {
    "notFound": {
      "p1": "Požadovaná stránka nebyla nalezena.",
      "title": "Stránka nenalezena"
    }
  },
  "theme": {
    "color": {
      "title": "Barevné schéma"
    },
    "picker": {
      "dark": "Tmavý režim",
      "light": "Světlý režim",
      "system": "Systém"
    }
  },
  "title": "Nomidio Identity",
  "topmenu": {
    "back": "Zpět",
    "help": "Zobrazit FAQ",
    "logo": {
      "alt": "Nomidio Identity"
    },
    "switch_user": "Přepnout uživatele"
  },
  "totp_code": {
    "copied_secret": "Tajný klíč zkopírován",
    "copy_secret": "Zkopírovat tajný klíč",
    "p1": "Naskenujte QR kód pomocí ověřovací aplikace nebo ručně zadejte tajný klíč.",
    "p2": "Na mobilním zařízení můžete klepnout na QR kód pro konfiguraci aplikace Google Authenticator (pokud je nainstalována).",
    "view_qr": "Zobrazit QR",
    "view_secret": "Zobrazit tajný klíč"
  },
  "unsupported": {
    "browser": {
      "challenge": {
        "error": {
          "preselected": "Obrázek výzvy jste již vybrali.",
          "unexpected": "Při výběru obrázku došlo k neočekávané chybě."
        }
      },
      "code": {
        "error": {
          "challenge": "Přihlášení v podporovaném prohlížeči ještě nebylo dokončeno",
          "invalid": "Zadaný ověřovací kód je neplatný",
          "unexpected": "Při ověřování vašeho kódu došlo k neočekávané chybě"
        }
      },
      "copy": {
        "button": "Zkopírovat odkaz do schránky"
      },
      "error": {
        "auth": "Nepodařilo se načíst přihlašovací adresu URL, chybí ověřovací kód.",
        "server": "Nepodařilo se načíst přihlašovací adresu URL kvůli chybě serveru. Zkuste to prosím později."
      },
      "image": {
        "button": "Vybrat obrázek"
      },
      "p1": "Zdá se, že používáte nepodporovaný prohlížeč. Přihlášení můžete dokončit v jiném prohlížeči podle níže uvedených pokynů.",
      "step1": {
        "p1": "Z bezpečnostních důvodů vyberte obrázek, který bude použit k propojení přihlášení napříč prohlížeči.",
        "title": "Krok 1. Vyberte obrázek"
      },
      "step2": {
        "p1": "Dokončete přihlášení v podporovaném prohlížeči s přístupem k mikrofonu a kameře pomocí odkazu, abyste získali ověřovací kód.",
        "p2": {
          "part1": "Naskenujte QR kód nebo zkopírujte ",
          "part2": " do podporovaného prohlížeče."
        },
        "p3": "Měl by se zobrazit obrázek, který jste vybrali v kroku 1.",
        "title": "Krok 2. Přihlaste se pomocí odkazu"
      },
      "step3": {
        "p1": "Po úspěšném přihlášení se zobrazí ověřovací kód. Zadejte prosím kód níže.",
        "title": "Krok 3. Zadejte ověřovací kód"
      }
    }
  },
  "user_details_dialog": {
    "a": "Proč to musím dělat?",
    "cancel": "Zrušit",
    "confirm": "Potvrdit",
    "p1": "Pro potvrzení vaší totožnosti bez dvoufaktorového ověřování nebo e-mailového ověření budete muset poskytnout další údaje o účtu.",
    "p2": {
      "phone": "Pro pokračování zadejte prosím níže své primární telefonní číslo."
    },
    "title": "Potřebujeme některé informace"
  },
  "voice_check": {
    "dialog": {
      "mic_troubleshoot": {
        "list": {
          "item1": "Váš mikrofon není ztlumený.",
          "item2": "Mikrofon nepoužíváte pro hlasový hovor.",
          "item3": "Je vybrán správný mikrofon.",
          "item4": "Mluvíte zřetelně do mikrofonu."
        },
        "ok": "OK",
        "p1": "CS Please ensure:",
        "p2": "CS Your page will now reload.",
        "title": "Není detekován žádný zvuk"
      }
    },
    "media_access": {
      "button": "Povolit přístup k mikrofonu",
      "p1": "Pro snímání vašeho hlasového biometrického vzoru potřebujeme váš souhlas s přístupem k mikrofonu.",
      "p2": "Povolte prosím přístup k mikrofonu.",
      "title": "Přístup k mikrofonu"
    },
    "media_error": {
      "button": "Obnovit",
      "p1": "Zkuste prosím obnovit stránku nebo aktualizovat oprávnění přístupu k mikrofonu v nastavení prohlížeče.",
      "title": "Přístup k mikrofonu byl odepřen"
    },
    "record": {
      "hint": {
        "firstRecording": "Klepněte na tlačítko nahrávání, přečtěte níže uvedenou frázi a klepněte znovu pro zastavení.",
        "polling": "Ověřuji na serveru…",
        "tapAgain": "Klepněte znovu pro ukončení nahrávání",
        "tooLong": "To trvalo příliš dlouho. Pro ukončení nahrávání musíte klepnout na tlačítko nahrávání.",
        "tooQuiet": "Nepodařilo se zachytit žádný zvuk.",
        "tooShort": "To bylo příliš krátké. Musíte mluvit pomaleji.",
        "training2": "Nyní frázi nahrajte znovu",
        "verification1": "Nyní potřebujeme ověřit, že je vše nastaveno správně. Nahrajte frázi znovu.",
        "verification2": "Nyní frázi nahrajte znovu",
        "waitingForUploads": "Čekám na dokončení nahrávání…"
      },
      "phrase": "„Svým hlasem prokazuji svou totožnost“",
      "recordButtonText": {
        "tapStart": "Klepněte pro spuštění",
        "tapStop": "Klepněte pro zastavení",
        "uploading": "Nahrávání"
      }
    }
  }
}
